export enum BonLivraisonTemperatureStatus {
  NA,
  Conforme,
  Tolere,
  NonConforme
}

// tslint:disable-next-line: variable-name
export const InvalidTemperatureStatuses = [BonLivraisonTemperatureStatus.NonConforme, BonLivraisonTemperatureStatus.Tolere];
